import PopupActions from '../../../actions/PopupActions';

class SuperuserApprovalAudit extends React.Component {

    constructor(props) {
        super(props);

    }
    render() {
        const guest = this.props.guest;
        return (
            <div className='popup popup__transparent'>
                <div
                    className='popup__content'
                    style={{'width' : '350px', 'height' : '150px'}}>

                    <div className='popup-header'>
                        Superuser Approval

                        <div
                            className='popup-close'
                            onClick={PopupActions.close}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>
                    <div>
                        <h6>Customer information access is audited. Do you want to continue?</h6>
                    </div>
                    <div
                        className='btn-green'
                        onClick={() => {
                            PopupActions.viewProfile(guest);
                        }}
                        style={{'width' : '110px', 'margin' : '10px 0 0 10px'}}>

                        Yes
                    </div>
                    <div
                        className='btn-green'
                        onClick={() => {
                            PopupActions.close();
                        }}
                        style={{'width' : '110px', 'margin' : '10px 0 0 10px'}}>

                        No
                    </div>
                </div>
            </div>
        );
    }
}

export default SuperuserApprovalAudit;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/compliance/SuperuserApprovalAudit.react.jsx